/**
 * Donut.js
 *
 * @class   Donut
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';

export default React.createClass({

	displayName: 'Donut',

	propTypes: {

	},

	render() {

		return <h3>Donut</h3>

	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/donut/Donut.js
 **/